import { computed, type Ref } from 'vue'
import { useScroll } from '@vueuse/core'

export const useChatMessages = (messagesContainer: Ref<HTMLElement | undefined>) => {
  const { arrivedState } = useScroll(messagesContainer, {
    behavior: 'smooth',
  })

  const scrollToBottom = () => {
    if (messagesContainer.value) {
      messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight
    }
  }

  const isAtBottom = computed(() => arrivedState.bottom)

  return {
    scrollToBottom,
    isAtBottom,
  }
}
